import { DEFAULT_LOCALE, getCatalogEntry, type SchemaLocale } from './catalog'
import { stripLocalePrefix } from './localePath'

/** Converte prefixo URL (minúsculo) para código BCP-47 do schema. */
export function prefixToSchemaLocale(prefix: string): string | null {
  const entry = getCatalogEntry(prefix)
  return entry?.code ?? null
}

/** Caminho público com prefixo de idioma (`pt` sem prefixo). */
export function buildLocalizedPath(
  path: string,
  locale: string | SchemaLocale,
  defaultLocale: string | SchemaLocale = DEFAULT_LOCALE,
): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  if (!locale || locale === defaultLocale) return normalized === '' ? '/' : normalized
  const urlPrefix = locale.toLowerCase()
  if (normalized === '/') return `/${urlPrefix}`
  return `/${urlPrefix}${normalized}`
}

/** Remove prefixo de idioma do pathname actual (para troca no seletor). */
export function stripPathForLocaleSwitch(pathname: string): string {
  const hit = stripLocalePrefix(pathname)
  return hit?.rest ?? pathname
}
